import { render, staticRenderFns } from "./EventTypeInferenceStep.vue?vue&type=template&id=4b38ce8f"
import script from "./EventTypeInferenceStep.vue?vue&type=script&lang=js"
export * from "./EventTypeInferenceStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports